import _regeneratorRuntime from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import router from '@/router';
import auth from '@/utils/auth';
import { Dialog, Toast } from 'vant';
import store from '@/store';
import { appInfo, initIframeToLink } from '@/utils/utils';
import App from '@/utils/app';
import UserApi from '@/api/user';

// 弹窗配置
var realNameDialogOption = {
  title: '',
  message: '应国家法律法规与平台要求，请进行实名认证！',
  confirmButtonText: '去认证',
  cancelButtonText: '暂不认证',
  closeOnClickOverlay: true
};
var realNameFailDialogOption = {
  title: '',
  message: "\u60A8\u7684\u5B9E\u540D\u8BA4\u8BC1\u672A\u901A\u8FC7\uFF0C\u8BF7\u91CD\u65B0\u8BA4\u8BC1\uFF1B\u88AB\u62D2\u539F\u56E0\uFF1A\u8BA4\u8BC1\u5931\u8D25",
  confirmButtonText: '重新认证',
  cancelButtonText: '暂不认证',
  closeOnClickOverlay: true
};
var realNamePendingMsg = '实名认证在审核中，请耐心等待~';
var walletStatusDialogOption = {
  title: '',
  message: '你尚未开通富友钱包，无法操作，请先开通钱包！',
  confirmButtonText: '开通钱包',
  cancelButtonText: '暂不开通',
  closeOnClickOverlay: true
};
var walletDisabledMsg = '钱包已禁用，无法使用！';
var realNameLottieDialog = {
  title: '',
  message: '您尚未完成实名认证，无法抽奖！',
  confirmButtonText: '实名认证',
  cancelButtonText: '暂不认证',
  closeOnClickOverlay: true
};
// 进化dialog配置
var realNameEvolutionDialog = _objectSpread(_objectSpread({}, realNameDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
});
var realNameEvolutionFailDialog = _objectSpread(_objectSpread({}, realNameFailDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
});
// Web3应用中心dialog设置
var realNameTPGameDialog = _objectSpread(_objectSpread({}, realNameDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
});
var realNameTPGameFailDialog = _objectSpread(_objectSpread({}, realNameFailDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
});

// 钱包在购买场景下支付通道是否可用
var payChannelDialogOption = {
  title: '',
  message: '你尚未开通任何钱包，无法购买，请先开通至少1个钱包！',
  confirmButtonText: '开通钱包',
  cancelButtonText: '暂不开通',
  closeOnClickOverlay: true
};
var yeePayChannelDialogOption = {
  title: '',
  message: '你尚未开通易宝钱包，无法购买！',
  confirmButtonText: '开通钱包',
  cancelButtonText: '暂不开通',
  closeOnClickOverlay: true
};

// 验证登录状态
export var validLogin = function validLogin(routePush) {
  return new Promise(function (resolve, reject) {
    if (appInfo) {
      // 如果app内打开
      store.dispatch('user/GetAppLogin').then(function () {
        resolve(true);
      }).catch(function () {
        // 未登录
        App.jumpLogin();
        reject(false);
      });
    } else {
      var token = auth.getToken() || '';
      // 未登录
      if (!token) {
        var _window$location = window.location,
          _window$location$path = _window$location.pathname,
          pathname = _window$location$path === void 0 ? '' : _window$location$path,
          _window$location$sear = _window$location.search,
          search = _window$location$sear === void 0 ? '' : _window$location$sear;
        if (routePush) {
          routePush("/login?redirect=".concat(pathname).concat(window.encodeURIComponent(search)));
        } else {
          router.push({
            name: 'Login',
            query: {
              redirect: "".concat(pathname).concat(window.encodeURIComponent(search))
            }
          });
        }
        reject(false);
      }
      resolve(true);
    }
  });
};

// 验证实名状态
export var validRealName = function validRealName(val) {
  return new Promise(function (resolve, reject) {
    var userInfo = auth.lsGetUserInfo() || {};
    var realNameInfo = auth.lsGetRealNameInfo() || {};
    // const DialogOption = val === 'Lottie' ? realNameLottieDialog : realNameDialogOption
    // 根据类型使用不同的dialog option
    var DialogOption;
    var FailDialogOption;
    switch (val) {
      case 'Lottie':
        DialogOption = realNameLottieDialog;
        FailDialogOption = realNameFailDialogOption;
        break;
      case 'evolution':
        // 进化dialog
        DialogOption = realNameEvolutionDialog;
        FailDialogOption = realNameEvolutionFailDialog;
        break;
      case 'TPGame':
        // Web3应用中心
        DialogOption = realNameTPGameDialog;
        FailDialogOption = realNameTPGameFailDialog;
        break;
      default:
        DialogOption = realNameDialogOption;
        FailDialogOption = realNameFailDialogOption;
    }
    var sceneMap = {
      Lottie: 'game',
      realNameExchangeRight: 'exchangeRight'
    };
    var scene = sceneMap[val] || '';
    if (userInfo.realNameAuth || realNameInfo.status === 's') {
      resolve(true);
    }
    // 实名失败
    if (!userInfo.realNameAuth && realNameInfo.status === 'f') {
      Dialog.confirm(_objectSpread(_objectSpread({}, FailDialogOption), {}, {
        message: "\u60A8\u7684\u5B9E\u540D\u8BA4\u8BC1\u672A\u901A\u8FC7\uFF0C\u8BF7\u91CD\u65B0\u8BA4\u8BC1\uFF1B\u88AB\u62D2\u539F\u56E0\uFF1A".concat(realNameInfo.refuseReason || '-')
      })).then(function () {
        // 如果app内打开未实名
        if (appInfo) {
          App.jumpRzPage();
        } else {
          router.push({
            name: 'FYPersonalAuth',
            query: {
              scene: scene
            }
          });
        }
      }).catch(function () {});
      reject(false);
      return;
    }
    // 实名中
    if (!userInfo.realNameAuth && realNameInfo.status === 'd') {
      Toast(realNamePendingMsg);
      reject(false);
      return;
    }
    // 未实名
    if (!userInfo.realNameAuth) {
      Dialog.confirm(_objectSpread({}, DialogOption)).then(function () {
        // 如果app内打开未实名
        if (appInfo) {
          App.jumpRzPage();
        } else {
          router.push({
            name: 'FYPersonalAuth',
            query: {
              scene: scene
            }
          });
        }
      }).catch(function () {
        reject(false);
      });
    }
  });
};

// 验证钱包状态
export var validWalletStatus = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref2, _ref2$status, status, _ref3, _ref3$signingUrl, signingUrl, _yield$store$dispatch, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = auth.lsGetFYWalletInfo() || {}, _ref2$status = _ref2.status, status = _ref2$status === void 0 ? null : _ref2$status;
          _ref3 = auth.lsGetFYWalletInfo() || {}, _ref3$signingUrl = _ref3.signingUrl, signingUrl = _ref3$signingUrl === void 0 ? '' : _ref3$signingUrl; // 无钱包状态, 手动获取
          if (!(status === null)) {
            _context.next = 8;
            break;
          }
          _context.next = 5;
          return store.dispatch('user/GetWalletStatus');
        case 5:
          _yield$store$dispatch = _context.sent;
          data = _yield$store$dispatch.data;
          status = data.status;
        case 8:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            // 钱包开通状态 0-未开通平台钱包未开通富有钱包 1-已开通平台钱包未开通富有钱包 2-富有钱包开通中 3-已开富有钱包 4-富有钱包开通失败 5-已禁用
            if ([0, 1, 2, 4].includes(status)) {
              Dialog.confirm(_objectSpread({}, walletStatusDialogOption)).then(function () {
                var routeNameMap = {
                  0: 'FYService',
                  1: 'cashWallet',
                  2: '',
                  4: 'cashWallet'
                };
                if (routeNameMap[status]) {
                  router.push({
                    name: routeNameMap[status]
                  });
                } else if (signingUrl) {
                  // 跳转至签约页
                  // window.open(signingUrl, '_self')
                  initIframeToLink(signingUrl);
                } else {
                  router.push({
                    name: 'cashWallet'
                  });
                }
              }).catch(function () {});
              reject(false);
            } else if (status === 5) {
              Toast(walletDisabledMsg);
              reject(false);
            }
            resolve(true);
          }));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function validWalletStatus() {
    return _ref.apply(this, arguments);
  };
}();

// 验证是否有可用的支付通道（包含富友&易宝&其他）
export var validPayChannelAble = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(scene, params) {
    var data, isWalletAble;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return store.dispatch('user/GetUserPaymentChannel', params);
        case 2:
          data = _context2.sent;
          isWalletAble = !!((data === null || data === void 0 ? void 0 : data.filter(function (x) {
            return x.status === 1;
          })) || []).length;
          return _context2.abrupt("return", new Promise(function (resolve, reject) {
            if (isWalletAble) {
              resolve(true);
            } else {
              Dialog.confirm(_objectSpread({}, payChannelDialogOption)).then(function () {
                router.push({
                  name: 'AccountIndex',
                  query: {
                    active: 'CAPITAL_ACCOUNT'
                  }
                });
              });
              reject(false);
            }
          }));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function validPayChannelAble(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
// 验证是否易宝支付通道
export var validYeePayChannelAble = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(scene, params) {
    var data, isWalletAble;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return store.dispatch('user/GetUserPaymentChannel', params);
        case 2:
          data = _context3.sent;
          isWalletAble = data.find(function (x) {
            return x.channelType === 'YEE_PAY' && x.status === 1;
          });
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            if (isWalletAble) {
              resolve(true);
            } else {
              Dialog.confirm(_objectSpread({}, yeePayChannelDialogOption)).then(function () {
                router.push({
                  name: 'AccountIndex',
                  query: {
                    active: 'CAPITAL_ACCOUNT'
                  }
                });
              });
              reject(false);
            }
          }));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function validYeePayChannelAble(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
// 验证是否开通钱包（富有和易宝钱包有其中一个开通就可以了）
export var validWalletChannelAble = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _yield$UserApi$getUse, _yield$UserApi$getUse2, data, isWalletAble;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return UserApi.getUserWalletList({
            scene: 'INDEX'
          });
        case 2:
          _yield$UserApi$getUse = _context4.sent;
          _yield$UserApi$getUse2 = _yield$UserApi$getUse.data;
          data = _yield$UserApi$getUse2 === void 0 ? [] : _yield$UserApi$getUse2;
          isWalletAble = !!(data.filter(function (x) {
            return x.walletStatus === 'SUCCESS';
          }) || []).length;
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            if (isWalletAble) {
              resolve(true);
            } else {
              Dialog.confirm(_objectSpread({}, payChannelDialogOption)).then(function () {
                router.push({
                  name: 'AccountIndex',
                  query: {
                    active: 'CAPITAL_ACCOUNT'
                  }
                });
              });
              reject(false);
            }
          }));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function validWalletChannelAble() {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * 权限验证
 * @param scene 场景值,目前只有[登录][实名][钱包][优了个优游戏实名]四种,且为包含关系
 * @param historyRoutePush 微服务提供的跳转方法, 适用于微服务跳转到主应用
 * @returns {Promise<unknown>}
 */
export var hasPermission = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var scene,
      data,
      historyRoutePush,
      params,
      isLogin,
      isRealName,
      hasWallet,
      result,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          scene = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : 'realName';
          data = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
          historyRoutePush = data.historyRoutePush, params = data.params;
          isLogin = false;
          isRealName = false;
          hasWallet = false;
          if (!(scene === 'login')) {
            _context5.next = 10;
            break;
          }
          _context5.next = 9;
          return validLogin(historyRoutePush);
        case 9:
          isLogin = _context5.sent;
        case 10:
          if (!(scene === 'realName')) {
            _context5.next = 18;
            break;
          }
          _context5.next = 13;
          return validLogin(historyRoutePush);
        case 13:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 18;
            break;
          }
          _context5.next = 17;
          return validRealName();
        case 17:
          isRealName = _context5.sent;
        case 18:
          if (!(scene === 'richPayChannelAble')) {
            _context5.next = 30;
            break;
          }
          _context5.next = 21;
          return validLogin(historyRoutePush);
        case 21:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 26;
            break;
          }
          _context5.next = 25;
          return validRealName();
        case 25:
          isRealName = _context5.sent;
        case 26:
          if (!isRealName) {
            _context5.next = 30;
            break;
          }
          _context5.next = 29;
          return validWalletStatus();
        case 29:
          hasWallet = _context5.sent;
        case 30:
          if (!(scene === 'realNameEvolution')) {
            _context5.next = 38;
            break;
          }
          _context5.next = 33;
          return validLogin(historyRoutePush);
        case 33:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 38;
            break;
          }
          _context5.next = 37;
          return validRealName('evolution');
        case 37:
          isRealName = _context5.sent;
        case 38:
          if (!(scene === 'realNameTPGame')) {
            _context5.next = 46;
            break;
          }
          _context5.next = 41;
          return validLogin(historyRoutePush);
        case 41:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 46;
            break;
          }
          _context5.next = 45;
          return validRealName('TPGame');
        case 45:
          isRealName = _context5.sent;
        case 46:
          if (!(scene === 'realNameLottie')) {
            _context5.next = 52;
            break;
          }
          isLogin = validLogin(historyRoutePush);
          if (!isLogin) {
            _context5.next = 52;
            break;
          }
          _context5.next = 51;
          return validRealName('Lottie');
        case 51:
          isRealName = _context5.sent;
        case 52:
          if (!(scene === 'realNameExchangeRight')) {
            _context5.next = 58;
            break;
          }
          isLogin = validLogin(historyRoutePush);
          if (!isLogin) {
            _context5.next = 58;
            break;
          }
          _context5.next = 57;
          return validRealName('realNameExchangeRight');
        case 57:
          isRealName = _context5.sent;
        case 58:
          if (!['payChannelAbleByBuy'].includes(scene)) {
            _context5.next = 70;
            break;
          }
          _context5.next = 61;
          return validLogin(historyRoutePush);
        case 61:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 66;
            break;
          }
          _context5.next = 65;
          return validRealName();
        case 65:
          isRealName = _context5.sent;
        case 66:
          if (!isRealName) {
            _context5.next = 70;
            break;
          }
          _context5.next = 69;
          return validPayChannelAble(scene, params);
        case 69:
          hasWallet = _context5.sent;
        case 70:
          if (!['yeePayChannelAble'].includes(scene)) {
            _context5.next = 82;
            break;
          }
          _context5.next = 73;
          return validLogin(historyRoutePush);
        case 73:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 78;
            break;
          }
          _context5.next = 77;
          return validRealName();
        case 77:
          isRealName = _context5.sent;
        case 78:
          if (!isRealName) {
            _context5.next = 82;
            break;
          }
          _context5.next = 81;
          return validYeePayChannelAble(scene, params);
        case 81:
          hasWallet = _context5.sent;
        case 82:
          if (!(scene === 'isOpenWallet')) {
            _context5.next = 94;
            break;
          }
          _context5.next = 85;
          return validLogin(historyRoutePush);
        case 85:
          isLogin = _context5.sent;
          if (!isLogin) {
            _context5.next = 90;
            break;
          }
          _context5.next = 89;
          return validRealName();
        case 89:
          isRealName = _context5.sent;
        case 90:
          if (!isRealName) {
            _context5.next = 94;
            break;
          }
          _context5.next = 93;
          return validWalletChannelAble(scene, params);
        case 93:
          hasWallet = _context5.sent;
        case 94:
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            var isScene = ['realName', 'realNameLottie', 'realNameEvolution', 'realNameExchangeRight', 'realNameTPGame'].includes(scene);
            var allWallet = ['payChannelAbleByBuy'].includes(scene);
            if (scene === 'login' && isLogin) {
              result = true;
            } else if (isScene && isLogin && isRealName) {
              result = true;
            } else if (scene === 'richPayChannelAble' && isLogin && isRealName && hasWallet) {
              // 富友钱包
              result = true;
            } else if (scene === 'yeePayChannelAble' && isLogin && isRealName && hasWallet) {
              // 易宝钱包
              result = true;
            } else if (scene === 'isOpenWallet' && isLogin && isRealName && hasWallet) {
              // 验证是否开通钱包（富有和易宝钱包有其中一个开通就可以了）
              result = true;
            } else if (allWallet && isLogin && isRealName && hasWallet) {
              // 平台所有钱包（包含富友&易宝）
              result = true;
            }
            if (result) {
              resolve(true);
            } else {
              reject(false);
            }
          }));
        case 95:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function hasPermission() {
    return _ref7.apply(this, arguments);
  };
}();